import React from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { DatePicker } from 'antd/es';

const datePickerStyles = {
  width: '100%',
};

const { Option } = Select;

const LastSection = ({ extrastocks, isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col offset={4} span={10}>
        <Form.Item label={t('Ragione sociale')} name='legal_name'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Data richiesta')} name='offer_date'>
          <DatePicker
            disabled={isView}
            placeholder={t('Inserisci testo')}
            showTime={{ format: 'HH:mm' }}
            format='DD MMMM YYYY HH:mm'
          />
        </Form.Item>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item label={t('Price')} name='price'>
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item
          label={t('Contratto - Canone utenze mensili')}
          name='consumption_price'
        >
          <Input disabled={isView} placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col offset={4} span={10}>
        <Form.Item label={t('Note contratto')} name='comment'>
          <Input.TextArea
            disabled={isView}
            rows={6}
            placeholder={t('Inserisci testo')}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(LastSection);
